module.exports = __webpack_public_path__ + "img/buyFail.8cbae512.png";